import { PaletteOptions } from '@mui/material/styles';

export const palette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#2E5BBA', // Deep Blue - Trust, knowledge, real estate industry
    light: '#5C7CCC', // Light Blue - Hover, active states
    dark: '#1E3F8A', // Dark Blue - Press state, important elements
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#7C3AED', // Purple - AI, innovation features
    light: '#A855F7',
    dark: '#5B21B6',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#DC2626',
    light: '#F87171',
    dark: '#991B1B',
  },
  warning: {
    main: '#D97706',
    light: '#FBBF24',
    dark: '#92400E',
  },
  info: {
    main: '#2563EB',
    light: '#60A5FA',
    dark: '#1D4ED8',
  },
  success: {
    main: '#059669',
    light: '#34D399',
    dark: '#047857',
  },
  grey: {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827',
  },
  background: {
    default: '#F9FAFB',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#111827',
    secondary: '#6B7280',
    disabled: '#9CA3AF',
  },
  divider: '#E5E7EB',
};

export default palette;